
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import { EnumCityStatus } from '@xt/client/entities/kindred-spirit/cities'
import CityCard from '../CityCard/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    CityCard,
    InfiniteLoading
  }
})
export default class CityListGird extends Vue {
  @Prop({ default: 0 }) marginTop!: number

  get body() {
    return {
      adcode: '',
      recommend: true,
      statusArr: [EnumCityStatus.Assistance, EnumCityStatus.Inited].join(',')
    }
  }

  get pagePagination() {
    return this.$store.$tonghao.Cities.pagePagination
  }

  get CityStore() {
    return this.$store.$tonghao.Cities
  }

  handleToCityPage(cityId: number) {
    if (!cityId) return

    this.$router.push({
      path: `/topic/city/${cityId}`
    })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
